import iro from '@jaames/iro';
import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCeZdApSn53SEbKl7Hakxs77xGm9-GfZMw",
    authDomain: "color-d86eb.firebaseapp.com",
    databaseURL: "https://color-d86eb-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "color-d86eb",
    storageBucket: "color-d86eb.firebasestorage.app",
    messagingSenderId: "787734096623",
    appId: "1:787734096623:web:3c5ac7ef1d6961dd48891a",
    measurementId: "G-WEF5YM56C5"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app)
const stringsDocRef = doc(db, 'survey241111', 'strings')
let uid = ''

const btn_next = document.querySelector('#btn_next')
const result = document.querySelector('#result')
const text = document.querySelector('#text')
const page_start = document.querySelector('#page_start')
const btn_start = document.querySelector('#btn_start')
const page_end = document.querySelector('#page_end')
const btn_intro = document.querySelector("#btn_intro")
const page_intro = document.querySelector("#page_intro")
const btn_text = document.querySelector("#btn_text")
const page_text = document.querySelector("#page_text")
const input_relate = document.querySelector("#input_relate")
const btn_ask = document.querySelector("#btn_ask")
const radio_sex = document.querySelectorAll('input[name="sex"]')
const input_age = document.querySelector('#input_age')
const radio_fam = document.querySelectorAll('input[name="fam"]')

let strings = []

getDoc(stringsDocRef)
    .then((snap) => {
        const data = snap.data().strings
        strings = data.split(',')
        setStage()
    })

let curIdx = 0

btn_start.onclick = () => {
    page_start.style.display = 'none'
}

btn_intro.onclick = () => {
    page_intro.style.display = 'none'
}

btn_text.onclick = () => {
    page_text.style.display = 'none'
}


const colorPicker = new iro.ColorPicker('#picker', {
    layout: [
        {
            component: iro.ui.Slider,
            options: {
                sliderType: 'saturation'
            }
        },
        {
            component: iro.ui.Slider,
            options: {
                sliderType: 'hue'
            }
        },
        {
            component: iro.ui.Slider,
            options: {
                sliderType: 'value'
            }
        },
    ]
});

colorPicker.on('color:change', function (color) {
    console.log(color.hexString)
    result.style.backgroundColor = color.hexString
})

const setStage = () => {
    colorPicker.color.set('#e6e6e6')
    input_relate.value = ''
    text.innerHTML = strings[curIdx]
}

btn_next.onclick = () => {
    console.log(radio_fam.value)
    page_text.style.display = 'flex'
}

btn_ask.onclick = () => {
    radio_sex.forEach((radio) => {
        if (radio.checked) {
            if (input_age.value !== '') {
                let valSex
                if (radio.id == 'radio_female') {
                    valSex = 'F'
                } else if (radio.id == 'radio_male') {
                    valSex = 'M'
                }

                uid = `uid${Date.now()}${Math.floor(Math.random() * 1000)}::${valSex}::${input_age.value}`

                page_ask.style.display = 'none'
            }
        }
    })
}

btn_text.onclick = () => {

    let familiarity = ''

    radio_fam.forEach((radio) => {
        if (radio.checked) {
            if (radio.id == 'fam_veryyes') familiarity = '매우그렇다';
            else if (radio.id == 'fam_yes') familiarity = '그렇다';
            else if (radio.id == 'fam_soso') familiarity = '보통이다';
            else if (radio.id == 'fam_no') familiarity = '아니다';
            else if (radio.id == 'fam_veryno') familiarity = '매우아니다';
        }
    })

    let relateString = ''
    if (input_relate.value.length > 0) {
        relateString = input_relate.value
    } else {
        relateString = '입력없음'
    }

    const colorValue = colorPicker.color.hexString
    const val = `${colorValue}::${relateString}::${familiarity}`

    const docRef = doc(db, "survey241111answers", uid);

    getDoc(docRef)
        .then((snap) => {
            if (snap.exists()) {
                return updateDoc(docRef, { [strings[curIdx]]: val })
            } else {
                return setDoc(docRef, { [strings[curIdx]]: val })
            }
        })
        .then(() => {
            if (curIdx < strings.length - 1) {
                console.log('updated')
                page_text.style.display = 'none'
                page_start.style.display = 'flex'
                curIdx++
                setStage()
            } else {
                page_end.style.display = 'initial'
            }
        })
        .catch((error) => {
            console.error(error)
        })
}

// firebase
// account : jay jung
// url : https://console.firebase.google.com/project/color-d86eb/overview